import React from 'react';
import { SVGProps } from './types';

const AlertIcon = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="square"
        d="M8 14.665A6.667 6.667 0 108 1.332a6.667 6.667 0 000 13.333z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
        d="M7.994 10.668h.008M8.001 8.097V4.668"
      />
    </svg>
  );
};

export { AlertIcon };
